var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col p-0"},[_c('div',{staticClass:"not-found-wrap text-center"},[_c('h1',{staticClass:"text-60"},[_vm._v("\n      404\n    ")]),_vm._v(" "),_c('p',{staticClass:"text-36 subheading mb-3"},[_vm._v(_vm._s(_vm.$t('404.0')))]),_vm._v(" "),_c('p',{staticClass:"mb-5  text-muted text-18"},[_vm._v(_vm._s(_vm.$t('404.1')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e6f16f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Module/404.vue
// module id = null
// module chunks = 